<template>
  <section class="component-list-course-collapse">
    <h4 class="text-right rtl font-18 mb-4">برنامه درسی برای این دوره</h4>
    <div v-for="(section,index) in items" :key="index">
      <div class="card-header rtl text-right" v-b-toggle="'div'+index">
        <toggle-open/>
        {{section.section_name}}
      </div>
      <div class="dec-sec rtl text-right" v-b-toggle="'div'+index">
        <p class="font-14 d-inline" v-if="section.section_description">
          <span class="info">توضیحات :</span>
          {{section.section_description}}
        </p>
      </div>
      <!-- :visible="index === expanded" -->
      <!-- accordion="my-accordion" -->
      <b-collapse
        :id="'div'+index"
        @hidden="clearLects(section,index)"
        @show="showLects(section,index)"
        :visible="index === expanded"
      >
        <!-- :aria-expanded="index === expanded"
         :aria-controls="'div'+index" -->
        <div class="content px-2 py-3">
          <div
            class="row d-flex row-item py-2"
            v-for="(lecture,i) in section.lectures"
            :key="i"
            v-if="section.lectures.length"
          >
            <div class="title col-sm-7 col-12 mb-3 mb-sm-0 justify-content-start rtl text-right">
              <p
                class="mb-0 d-flex align-items-center text-right d-inline-block pointer"
                @click="getPlay(lecture,i)"
              >
                <i class="flaticon-play icon-22 d-inline-block mx-1"></i>
                <span class="font-14">قسمت {{lecture.lecture_num}} : {{lecture.lecture_name}}</span>
              </p>
            </div>
            <div class="col-sm-5 col-12">
              <div class="d-flex flex-row justify-content-center">
                <div
                  v-if="lecture.has_file"
                  class="col-1 text-center"
                  data-balloon-pos="up"
                  data-balloon="این قسمت دارای فایل آموزشی میباشد"
                >
                  <i
                    class="flaticon-attach icon-22 text-info pointer"
                    @click="downloadFile(section, index, lecture, i)"
                  ></i>
                </div>
                <div
                  class="info col-4 text-center"
                  v-if="isShow || lecture.is_preview"
                  @click="getPlay(lecture,i)"
                >
                  <p
                    class="mb-0 font-14 d-flex align-items-center"
                    data-balloon-pos="up"
                    data-balloon="نمایش"
                  >
                    <i class="flaticon-eye icon-22 ml-2"></i>
                    نمایش
                  </p>
                </div>
                <div
                  v-else-if="!lecture.is_preview"
                  class="col-1 text-center"
                  data-balloon-pos="up"
                  data-balloon="برای مشاهده این قسمت باید دوره را خریداری کنید"
                >
                  <i class="flaticon-lock icon-22 m-auto"></i>
                </div>
                <div
                  v-if="item.downloadable"
                  @click="downloadVideo(lecture,i)"
                  class="info col-2 pointer text-center"
                  data-balloon-pos="up"
                  data-balloon="دانلود ویدئو"
                >
                  <i class="flaticon-down-arrow icon-22 m-auto"></i>
                </div>
              </div>
            </div>
            <div
              class="col-12 justify-content-start rtl text-right"
              v-if="lecture.lecture_description"
            >
              <p class="font-12 dec-lect d-inline">
                <span class="info">توضیحات :</span>
                {{lecture.lecture_description}}
              </p>
            </div>
            <!-- <div class="info  col-1 justify-content-end"
                 v-else
                 @click="getEnroll(section,lecture)">
              <p class="mb-0 font-14">نمایش</p>
            </div>-->
          </div>

          <div
            class="d-flex row-item py-2"
            v-for="(item,i) in 4"
            :key="i"
            v-if="!section.lectures.length"
          >
            <div class="title col-1 justify-content-start rtl text-right">
              <content-loader :height="10" :speed="2" :animate="true"></content-loader>
            </div>
            <div class="title col-9 justify-content-start rtl text-right">
              <content-loader :height="10" :speed="2" :animate="true"></content-loader>
            </div>
            <div class="info col-2 justify-content-end">
              <p class="mb-0 font-14">
                <content-loader :height="10" :speed="2" :animate="true"></content-loader>
              </p>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
  </section>
</template>

<script>
  import toggleOpen from "cp/min-component/open-colose.vue";

  export default {
    name: "list-course-collapse",
    props: {
      isShow: {
        type: Boolean,
        default: false,
        required: false
      }
    },

    components: {
      toggleOpen
    },
    data() {
      return {
        file: "",
        open: true,
        expanded: -1,
        items: [],
        showId: null
      };
    },
    mounted() {
      var vm = this;
      this.getSections();
      // setTimeout(() => {
      // }, 0.9);
    },
    computed: {
      courseId() {
        return this.$route.params.id;
      },
      item() {
        return this.$store.state.courses.courseDetail;
      }
    },
    destroyed() {
      this.items = [];
    },
    methods: {
      download(filename, text) {
        window.open(text, "_blank");
      },
      async downloadFile(section, index, lecture, i) {
        try {
          if (!this.chcecAction(i)) return;
          if (!this.isShow) {
            this.$root.showWarnMsg({
              title: "محدودیت",
              message: "برای مشاهده فایل باید دوره راه خریداری کرده باشید"
            });
            return;
          }
          let body = {
            course: parseInt(this.$route.params.id),
            lecture: lecture.id,
            section: section.section_id
          };

          let {data} = await axios.post("/course-files/get", body);
          if (data.state !== 200) return;
          let fileName = data.file[0].attachedFile.split(".");
          this.download(
            `${lecture.lecture_name}.${fileName[fileName.length - 1]}`,
            this.appUrl.media + "/" + data.file[0].attachedFile
          );
        } catch (error) {
          console.log(error);
        }
      },
      expandAll() {
      },
      clearLects(section, index) {
        // if (this.items && this.items[index].lectures.length) {
        //   this.$set(this.items[index], 'lectures', [])
        // }
      },
      async showLects(item, index) {

        this.showId = false;
        this.isLoading = true;
        let res = await this.$store.dispatch("courses/getLects", {
          id: item.section_id
        });
        if (res.length) {
          this.items[index].lectures = [];
          this.$set(this.items[index], "lectures", res);

          if (index === 0 && this.items[index].lectures[0].is_preview) {
            this.showId = true;
          }
        } else {
          this.$root.showInfoMsg({
            title: "",
            message: "قسمتی برای این فصل تعریف نشده است"
          });
          // this.expanded = true
        }
        this.isLoading = false;
      },
      my_custom_action: function (vm) {
        this.open = !vm.status;
      },
      getEnroll(section, lecture) {
      },
      chcecAction(index) {
        this.showId = true;
        if (this.showId && index === 0) return true;
        if (!this.isLogin) {
          this.$store.commit("auth/setRedirect", false);
          this.showModalLogin();
          return false;
        } else {
          return true;
        }
      },
      async downloadVideo(item, index) {
        try {
          if (!this.chcecAction(index)) return;
          let {data} = await axios.post("/lecture/get-video-lecture-for-dl", {
            id: item.id
          });
          if (data.state != 200) return;
          let fileName = data.video.split(".");
          this.download(
            `${item.lecture_name}.${fileName[fileName.length - 1]}`,
            this.appUrl.media + "/" + data.video
          );
        } catch (error) {
          console.log(error);
        }
      },
      async getPlay(item, index) {
        try {
          if (!this.chcecAction(index)) return;
          let data = await this.$store.dispatch("courses/getVideo", {
            id: item.id
          });
          if (data.state === 200) {
            if (data.enc) {
              this.playVideoEnc(data.video);
            } else {
              this.playVideo(data.video);
            }
          } else {
            this.$store.commit("notifications/error", {
              message: 'اطلاعت دوره یافت نشد',
              title: "تماس با پشتیبان"
            });
          }
        } catch (error) {
          console.log(error);
        }
      },
      async getSections() {
        let res = await this.$store.dispatch("courses/getSections", {
          id: this.courseId
        });
        if (res && res.length > 0) {
          res.forEach(e => {
            e.lectures = [];
          });
          this.items.push(...res);
          // setTimeout(() => {
          //   vm.expanded = this.items.length - 1
          // }, 0.9)
        }
        this.isLoading = false;
        this.expanded = 0;
        this.showLects(this.items[0], 0)

      }
    }
  };
</script>
<style lang="less">
  @import (reference) "../../assets/css/variable.less";

  @blueLine: #007791;
  .component-list-course-collapse {
    .box-clear;

    .card-header {
      cursor: pointer;
      display: flex;
      align-items: center;
      background: #f9f9f9;
      border: none;
      cursor: pointer;
      height: auto;
      margin-top: 3px;
      padding: 10px 15px 0 10px;
      color: @secondaryTextColor;

      i {
        margin-left: 10px;
      }
    }

    .dec-lect {
      // border-top: 1px solid #e3e3e3;
      color: #666;
    }

    .dec-sec {
      clear: both;
      background: #f9f9f9;
      cursor: pointer;
      height: auto;
      padding: 10px 15px 10px 10px;
      color: @secondaryTextColor;
    }

    .content {
      background-color: @withe;
    }

    .row-item {
      border-bottom: 1px solid @e3;

      &:last-child {
        border-bottom: none;
      }

      .title {
        color: @blueLine;
        // margin-bottom: 9px;
        i {
          transform: scale(-1, -1);
        }
      }

      .info {
        color: @blueLine;

        p {
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/min-component/list-course-collapse.vue